import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-next--sprite",
  "use": "arrow-next--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-next--sprite\">\n<path d=\"M8.66663 0L7.25663 1.41L12.8366 7H0.666626V9H12.8366L7.25663 14.59L8.66663 16L16.6666 8L8.66663 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol